export const FETCH_USER_TRAVEL = 'FETCH_USER_TRAVEL';
export const FETCH_USER_TRAVEL_BEGIN = 'FETCH_USER_TRAVEL_BEGIN';
export const FETCH_USER_TRAVEL_FAILURE = 'FETCH_USER_TRAVEL_FAILURE';
export const TRAVEL = 'TRAVEL';